import * as React from 'react'
import styled from 'styled-components'
import areAdsAllowed from '../../../services/ads/areAdsAllowed'

const Wrapper = styled.div`
  display: none;
  place-content: center;
  min-width: 320px;
`

export default () => {
  React.useEffect(() => {
    if (
      areAdsAllowed() &&
      process.env.NODE_ENV === 'production' &&
      process.env.REACT_APP_DISABLE_ADS === 'false'
    ) {
      window.adsbygoogle = window.adsbygoogle || []
      window.adsbygoogle.push({})
    }
  }, [])

  if (
    areAdsAllowed() &&
    process.env.NODE_ENV === 'production' &&
    process.env.REACT_APP_DISABLE_ADS === 'false'
  ) {
    return (
      <Wrapper>
        <ins
          className="adsbygoogle"
          style={{ display: 'block', width: 320, height: 50, margin: 'auto' }}
          data-ad-client="ca-pub-7151132540209765"
          data-ad-slot="3258630683"
        ></ins>
      </Wrapper>
    )
  }

  return <Wrapper />
}
